/**
 * Extrai o nome original de um arquivo a partir da key do S3.
 *
 * As keys são geradas no formato `{prefix}/{timestamp}-{uuid}-{nomeOriginal}`
 * (ex.: `inspections/.../1780587187253-8063a1bb-b16c-45cb-8b75-554b7ea5aed2-gf.png`).
 * Esta função descarta o prefixo de pasta e o trecho `{timestamp}-{uuid}-`,
 * retornando apenas o nome legível (ex.: `gf.png`).
 *
 * Caso a key não siga o padrão esperado, retorna o último segmento intacto.
 */
export function extractOriginalName(key: string): string {
  const filename = key.split('/').pop() ?? key;
  return filename.replace(
    /^\d+-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i,
    ''
  );
}
